export default __webpack_public_path__ + "static/media/bracket-arrow-start-grey.7f7c4556.svg";